import React, { useEffect, useState } from 'react'
import Main from '../cpn/Main'
import PageTitle from '../cpn/PageTitle'
import { useShangpinjiaochengListQuery } from '../store/DianShangYeWuApi';
import { Divider, List, } from 'antd';
import classes from '../cpn/cpn.module.css'
function DeskCourse() {
    const [list, setList] = useState([]);    
    const dd_eowg_id = JSON.parse(localStorage.getItem('v120101_dd_eowg_id'));
    const {data, isSuccess} = useShangpinjiaochengListQuery({spjc_sp_id:dd_eowg_id});
    useEffect(() => {
        if (isSuccess) {
            // console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {spjc_id:key,spjc_name,spjc_content,spjc_qx,spjc_state,spjc_uname,spjc_ctime} = item;                 
                    return item = {key,spjc_name,spjc_content,spjc_qx,spjc_state,spjc_uname,spjc_ctime}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.spjc_ctime;
                    let bTimeString = b.spjc_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return aTime - bTime;     
                    },)
                setList(sortArr)
            }else{
                setList([])
            }
            
        }
    }, [data, isSuccess])
    
    return (
        <Main selectedKeys={['/DeskCourse']}>
            <PageTitle title='视频教程'/>
            <List style={{marginTop:"10px",padding:"20px"}}>
                {list.map((item) => {
                    return  <div key={item.key}>
                                <div className={classes.helpTitle}>{item.spjc_name}</div>
                                <div dangerouslySetInnerHTML={{__html:item.spjc_content}}  className={classes.helpContent}></div>
                                <Divider/>
                            </div>
                })}
            </List>
        </Main>
    )
}

export default DeskCourse